<template>
  <div id="navigationbar" v-if="showNav">


    <div>
    </div>

    <div id="navigationbar-title">{{title}}</div>

    <div>
    </div>

  </div>
</template>

<script>

  export default {
    name: 'navigationbar',
    props: ['title'],
    data () {
      return {
//        title: '2'
      }
    },
    mounted () {
    },
    destroyed () {
    },
    computed: {
      showNav() {
        return !this.utils.isWXUA()
      }
    }
  }
</script>


<style lang="scss">
  @import '../../../assets/css/mixin';


  #navigationbar {
    height: 44px;
    display: -webkit-flex; /* Safari */
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #1B1B1F;
  }
  #navigationbar-title {
    font-size: pxToRem(38px);
    color: white;
  }
</style>



// WEBPACK FOOTER //
// navigationbar.vue?deadbee8